export const FinanceUploadRequestsViewControls = {
  viewControl: {
    dateFilterOptions: [{ key: 'created_at', val: 'Created At' }],
  },
};

export const uploadRequestsColumns = [
  {
    title: 'Created At',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 180,
  },
  {
    title: 'Excel Action Type',
    dataIndex: 'action_type',
    key: 'action_type',
    width: 220,
  },
  {
    title: 'Employee Code',
    dataIndex: 'employee_code',
    key: 'employee_code',
    width: 150,
  },
  {
    title: 'Total Entries No',
    dataIndex: 'total_entries',
    key: 'total_entries',
    width: 140,
  },
  {
    title: 'Success Entries',
    dataIndex: 'success_entries',
    key: 'success_entries',
    width: 140,
  },
  {
    title: 'Ongoing Entries',
    dataIndex: 'ongoing_entries',
    key: 'ongoing_entries',
    width: 140,
  },
  {
    title: 'Failed Entries',
    dataIndex: 'failed_entries',
    key: 'failed_entries',
    width: 140,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 120,
  },
];
